export const NAVIGATIONBAR = 'navigationBar/NAVIGATIONBAR';
export const TOGGLE = 'navigationBar/TOGGLE';
export const ONSELECT = 'navigationBar/ONSELECT';
export const SET_COUNTY = 'navigationBar/SET_COUNTY';